import { MARK_CLASS } from './palette'

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** One case-insensitive pattern for all the words, longest first so "rest" does not split "restore". */
export function wordsPattern(words: readonly string[]): RegExp | null {
    const clean = words.filter(Boolean)
    if (!clean.length) return null
    const alternatives = clean
        .slice()
        .sort((a, b) => b.length - a.length)
        .map(escapeRe)
        .join('|')
    // The words are escaped above, so this is a literal alternation, not user-supplied regex.
    // eslint-disable-next-line security/detect-non-literal-regexp
    return new RegExp(`(${alternatives})`, 'gi')
}

/**
 * Mark the search words inside already-rendered (sanitised) rich text, touching TEXT NODES only,
 * never markup: each match is split out of its text node and wrapped in a <mark> created with the
 * DOM API. Nothing is parsed as HTML.
 */
export function highlightTextNodes(root: HTMLElement, words: readonly string[]): void {
    const re = wordsPattern(words)
    if (!re) return
    const walker = root.ownerDocument.createTreeWalker(root, NodeFilter.SHOW_TEXT)
    const nodes: Text[] = []
    while (walker.nextNode()) nodes.push(walker.currentNode as Text)
    for (const node of nodes) {
        const text = node.data
        re.lastIndex = 0
        if (!re.test(text)) continue
        const frag = root.ownerDocument.createDocumentFragment()
        text.split(re).forEach((part, i) => {
            if (!part) return
            if (i % 2 === 1) {
                const mark = root.ownerDocument.createElement('mark')
                mark.className = MARK_CLASS
                mark.textContent = part
                frag.appendChild(mark)
            } else {
                frag.appendChild(root.ownerDocument.createTextNode(part))
            }
        })
        node.parentNode?.replaceChild(frag, node)
    }
}
